import JavascriptHelpers from "../../../../../lib/Javascript/JavascriptHelpers";
export default class ReceiptLineEditorModel {
    constructor(){
        this.lineId = ""; // not on grid
        this.lineNbr = "";
        this.poolId = "";
        this.poolName = ""; // not on grid
        this.blockId = "";
        this.blockName = "";  // not on grid
        this.commodityId = "";
        this.commodityName = "";
        this.styleId = "";
        this.styleName = "";
        this.sizeId = "";
        this.sizeName = "";
        this.uomId = "";
        this.uomName = "";
        this.labelId = "";
        this.labelName = "";
        this.methodId = ""; 
        this.methodName = ""
        this.regionId = "";
        this.regionName = "";
        this.varietyId = "";
        this.varietyName = "";
        this.storageId = "";
        this.storageName = "";
        this.growerId = "";
        this.growerName = "";
        this.growerNbr = "";
        this.grade = "";


        this.itemPalletDefaultCubeQty = 0; // not on grid
        this.itemId = "";  // not on grid
        this.itemName = "";

        this.tagLineQty = 0;  // not on grid
        this.aggregateLineQty = 0; 
        this.diffLineQty = 0;  // not on grid

        this.pallets = []; // not on grid

        this.lotHash = -1;

        this.flushLineProps = this.flushLineProps.bind(this);


    }

    flushLineProps(){
        this.poolId = "";
        this.poolName = "";
        this.blockId = "";
        this.blockName = "";  // not on grid
        this.commodityId = "";
        this.commodityName = "";
        this.styleId = "";
        this.styleName = "";
        this.sizeId = "";
        this.sizeName = "";
        this.uomId = "";
        this.uomName = "";
        this.labelId = "";
        this.labelName = "";
        this.methodId = "";
        this.methodName = ""
        this.regionId = "";
        this.regionName = "";
        this.varietyId = "";
        this.varietyName = "";
        this.storageId = "";
        this.storageName = "";
        this.growerId = "";
        this.growerName = "";
        this.growerNbr = "";
     


        this.itemPalletDefaultCubeQty = 0; // not on grid
        this.itemId = "";  // not on grid
        this.itemName = "";
    }

    isModelEmpty(){
        if (!this.isPropEmpty("poolId")) return false;
        if (!this.isPropEmpty("blockId")) return false;
        if (!this.isPropEmpty("commodityId")) return false;
        if (!this.isPropEmpty("styleId")) return false;
        if (!this.isPropEmpty("sizeId")) return false;
        if (!this.isPropEmpty("uomId")) return false;
        if (!this.isPropEmpty("labelId")) return false;
        if (!this.isPropEmpty("methodId")) return false;
        if (!this.isPropEmpty("regionId")) return false;
        if (!this.isPropEmpty("varietyId")) return false;
        if (!this.isPropEmpty("storageId")) return false;
        return true;
    }

    isPropEmpty(propName){
        return (!this[propName] || this[propName]==="" || this[propName]==="undefined");
    }

    toLotHash(){
        this.lotHash = this.toStableHash(128);
    }

    toStableHash(hashLength){
        var hashString = this.itemId + ":" +
            this.poolId + ":" +
            this.blockId + ":" +
            this.commodityId + ":" +
            this.styleId + ":" + 
            this.sizeId + ":" +
            this.uomId + ":" + 
            this.labelId + ":" +
            this.methodId + ":" +
            this.regionId + ":" +
            this.varietyId + ":" +
            this.storageId + ":" +
            this.grade;
            
        // return JavascriptHelpers.getStableHash(hashString, hashLength);
        return JavascriptHelpers.simpleHash(hashString)
    }





}